import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from "@mui/material";
import OrderSummary from "./OrderSummary";
import { format } from "date-fns";

export default function ExpandableOrderCard({ order }) {
  return (
    <Stack key={order.id} mb={2}>
      <Accordion>
        <AccordionSummary>
          <Stack direction="row" gap={2}>
            <Typography variant="h6">Order #{order.id}</Typography>
            {order.status === 'paid' && <Typography variant="h6">Paid for on {format(new Date(order.payment_confirmed_at), 'LLL dd, yyyy @ h:mm aa')}</Typography>}
          </Stack>
        </AccordionSummary>
        <AccordionDetails>
          <OrderSummary order={order} />
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
}